
import React from "react";

function Search({
  search,
  onSearch,
  placeholder = "Search...",
}) {

  return (
    <div className="search-box">

      <input
        type="text"
        className="form-control"
        placeholder={placeholder}
        value={search || ""}
        onChange={(e) =>
          onSearch(e.target.value)
        }
      />

    </div>
  );
}

export default Search;